import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import FactaOfflineBatches from './Index.vue';

export const routes = [
  {
    path: 'facta-offline-lotes',
    name: 'talkvia_facta_offline_batches',
    meta: {
      permissions: ['administrator'],
      superAdminOrAdmin: true,
    },
    featureFlag: FEATURE_FLAGS.TALKVIA_CORBAN_FACTA_OFFLINE,
    component: FactaOfflineBatches,
  },
];
